<template>
  <div>
    <SearchBox ref="SearchBox">
      <template slot="form">
        <div class="selectInfo">
          <span class="topSty" style="font-size: 1.1vw; flex: 1">计划保养看板</span>
          <div class="topsele">
            <div class="topSty">
              <span>工厂：</span>
              <el-select v-model="fcIdSelected" placeholder="请选择工厂" :clearable="isclear" :disabled="ischeck" filterable @change="fcChange">
                <el-option v-for="factory in factoryList" :key="factory.value" :label="factory.label" :value="factory.value"></el-option>
              </el-select>
            </div>
            <div class="topSty">
              <span>车间：</span>
              <el-select v-model="shopSelected" placeholder="请选择车间" clearable filterable @change="shopChange">
                <el-option v-for="shop in shopList" :key="shop.value" :label="shop.label" :value="shop.value"></el-option>
              </el-select>
            </div>
            <div class="topSty">
              <span>工段：</span>
              <el-select v-model="sectionSelected" placeholder="请选择工段" clearable filterable @change="sectionChange">
                <el-option v-for="section in sectionList" :key="section.value" :label="section.label" :value="section.value"></el-option>
              </el-select>
            </div>
            <div class="topSty">
              <span>产线：</span>
              <el-select v-model="lineSelected" placeholder="请选择季度" clearable filterable @change="lineChange">
                <el-option v-for="line in lineList" :key="line.value" :label="line.label" :value="line.value"></el-option>
              </el-select>
            </div>
            <div class="topSty">
              <span>季度：</span>
              <el-select v-model="quarter" placeholder="请选择产线" clearable filterable @change="getPlanMaintainTotality">
                <el-option v-for="line in quarterList" :key="line.value" :label="line.label" :value="line.value"></el-option>
              </el-select>
            </div>
            <div class="topSty">
              <span>保养时间(年)：</span>
              <el-date-picker v-model="year" type="year" placeholder="选择日期"></el-date-picker>
            </div>
            <div class="topSty">
              <span>保养时间(月)：</span>
              <el-date-picker v-model="timeValue" type="month" placeholder="选择日期"></el-date-picker>
            </div>
            <div class="topSty" style="margin-top: 20px">
              <el-button type="primary" @click="getPlanMaintainTotality">手动刷新</el-button>
            </div>
            <div class="topSty" style="margin-top: 20px" v-if="isSkip">
              <el-button @click="getFacility">返回</el-button>
            </div>
          </div>
        </div>
      </template>
    </SearchBox>
    <SearchBox ref="SearchBox">
      <template slot="form">
        <div class="currentNum">
          <div style="display: flex" class="Sty1">
            <div style="flex: 1">
              <p>总产线数</p>
              <h3 class="Sty1 styColor1">{{ searchData.totalLines }}</h3>
            </div>
            <div style="flex: 1">
              <p>保养产线数</p>
              <h3 class="Sty1 styColor1">{{ searchData.numLines }}</h3>
            </div>
            <div style="flex: 1">
              <p>总设备数</p>
              <h3 class="Sty1 styColor1">{{ searchData.totalDevices }}</h3>
            </div>
            <div style="flex: 1">
              <p>保养设备数</p>
              <h3 class="Sty1 styColor1">{{ searchData.numDevices }}</h3>
            </div>
            <div style="flex: 1">
              <p>总保养数量</p>
              <h3 class="Sty1 styColor1">{{ searchData.total }}</h3>
            </div>
            <div style="flex: 1">
              <p>完成保养数量</p>
              <h3 class="Sty1 styColor1">{{ searchData.completionTotal }}</h3>
            </div>
            <div style="flex: 1">
              <p>完成率</p>
              <h3 class="Sty1 styColor1">{{ searchData.completionRate }}%</h3>
            </div>
            <div style="flex: 1">
              <p>按时保养完成率</p>
              <h3 class="Sty1 styColor1">{{ searchData.comRateOnSchedule }}%</h3>
            </div>
          </div>
        </div>
      </template>
    </SearchBox>
    <div>
      <div class="tabs">
        <el-tabs style="width: 97%; margin: 1vh 1vw 1vh 1vw" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="待接单" name="create">
            <el-table :data="tableData" stripe style="width: 100%" @current-change="planCurrentChange">
              <el-table-column prop="pmoNo" label="保养编号" align="center"></el-table-column>
              <el-table-column prop="orderCreateType.desc" label="保养类型" align="center"></el-table-column>
              <el-table-column prop="mainTity" label="保养数量" align="center"></el-table-column>
              <el-table-column prop="compTity" label="完成数量" align="center"></el-table-column>
              <el-table-column prop="numNorMain" label="保养异常数量" align="center"></el-table-column>
              <el-table-column prop="createTime" label="保养时间" align="center" width="155"></el-table-column>
              <el-table-column prop="fcName" label="所属工厂" align="center"></el-table-column>
              <el-table-column prop="shopName" label="所属车间" align="center"></el-table-column>
              <el-table-column prop="lineName" label="所属产线" align="center"></el-table-column>
              <el-table-column prop="devCode" label="设备编号" align="center"></el-table-column>
              <el-table-column prop="devName" label="设备名称" align="center"></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="待完成" name="wait_complete">
            <el-table :data="tableData" stripe style="width: 100%" @current-change="planCurrentChange">
              <el-table-column prop="pmoNo" label="保养编号" align="center"></el-table-column>
              <el-table-column prop="orderCreateType.desc" label="保养类型" align="center"></el-table-column>
              <el-table-column prop="mainTity" label="保养数量" align="center"></el-table-column>
              <el-table-column prop="compTity" label="完成数量" align="center"></el-table-column>
              <el-table-column prop="numNorMain" label="保养异常数量" align="center"></el-table-column>
              <el-table-column prop="createTime" label="保养时间" align="center" width="155"></el-table-column>
              <el-table-column prop="fcName" label="所属工厂" align="center"></el-table-column>
              <el-table-column prop="shopName" label="所属车间" align="center"></el-table-column>
              <el-table-column prop="lineName" label="所属产线" align="center"></el-table-column>
              <el-table-column prop="devCode" label="设备编号" align="center"></el-table-column>
              <el-table-column prop="devName" label="设备名称" align="center"></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="待验收" name="wait_accept">
            <el-table :data="tableData" stripe style="width: 100%" @current-change="planCurrentChange">
              <el-table-column prop="pmoNo" label="保养编号" align="center"></el-table-column>
              <el-table-column prop="orderCreateType.desc" label="保养类型" align="center"></el-table-column>
              <el-table-column prop="mainTity" label="保养数量" align="center"></el-table-column>
              <el-table-column prop="compTity" label="完成数量" align="center"></el-table-column>
              <el-table-column prop="numNorMain" label="保养异常数量" align="center"></el-table-column>
              <el-table-column prop="createTime" label="保养时间" align="center" width="155"></el-table-column>
              <el-table-column prop="fcName" label="所属工厂" align="center"></el-table-column>
              <el-table-column prop="shopName" label="所属车间" align="center"></el-table-column>
              <el-table-column prop="lineName" label="所属产线" align="center"></el-table-column>
              <el-table-column prop="devCode" label="设备编号" align="center"></el-table-column>
              <el-table-column prop="devName" label="设备名称" align="center"></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="已完成" name="complete">
            <el-table :data="tableData" stripe style="width: 100%" @current-change="planCurrentChange">
              <el-table-column prop="pmoNo" label="保养编号" align="center"></el-table-column>
              <el-table-column prop="orderCreateType.desc" label="保养类型" align="center"></el-table-column>
              <el-table-column prop="mainTity" label="保养数量" align="center"></el-table-column>
              <el-table-column prop="compTity" label="完成数量" align="center"></el-table-column>
              <el-table-column prop="numNorMain" label="保养异常数量" align="center"></el-table-column>
              <el-table-column prop="createTime" label="保养时间" align="center" width="155"></el-table-column>
              <el-table-column prop="fcName" label="所属工厂" align="center"></el-table-column>
              <el-table-column prop="shopName" label="所属车间" align="center"></el-table-column>
              <el-table-column prop="lineName" label="所属产线" align="center"></el-table-column>
              <el-table-column prop="devCode" label="设备编号" align="center"></el-table-column>
              <el-table-column prop="devName" label="设备名称" align="center"></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <el-pagination style="margin-top: 3vh" background @size-change="paginationChange" @current-change="paginationCurrentChange" :current-page="searchParams.page" :page-sizes="[10, 20, 50, 100]"
                       :page-size="searchParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="searchParams.pageCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      activeName: 'create',
      timeValue: '',
      year: '',
      quarter: '',
      quarterList: [
        {
          label: "第一季度",
          value: '1'
        },
        {
          label: "第二季度",
          value: '2'
        },
        {
          label: "第三季度",
          value: '3'
        },
        {
          label: "第四季度",
          value: '4'
        },
      ],
      tableData: [],
      factoryTree: [],
      fcIdSelected: '',
      sectionSelected: '',
      shopSelected: '',
      lineSelected: '',
      userInfo: {},
      role: {},
      ischeck: true,
      isclear: false,
      isChange: true,
      searchData: {
        completionRate: '',
        completionTotal: '',
        total: ''
      },
      searchParams: {
        param: {},
        pageSize: 10,
        page: 1,
        pageCount: 0
      },
      intervalId: null,
      isSkip: false,
      upkeepStateArray: {}
    }
  },
  computed: {
    factoryList: function () {
      var arr = []
      var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      if (this.factoryTree != undefined && this.factoryTree.length > 0) {
        if (this.ischeck) {
          for (var i = 0; i < this.factoryTree.length; i++) {
            for (let j = 0; j < userInfo.roles.length; j++) {
              if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                arr.push({
                  label: this.factoryTree[i].deptName,
                  id: this.factoryTree[i].deptID,
                  value: JSON.stringify(this.factoryTree[i]),
                  deptLevel: this.factoryTree[i].deptLevel,
                  parent: 0
                })
              }
            }
          }
        } else {
          for (var i = 0; i < this.factoryTree.length; i++) {
            arr.push({
              label: this.factoryTree[i].deptName,
              id: this.factoryTree[i].deptID,
              value: JSON.stringify(this.factoryTree[i]),
              deptLevel: this.factoryTree[i].deptLevel,
              parent: 0
            })
          }
        }
      }
      return arr
    },
    shopList: function () {
      var arr = []
      if (this.fcIdSelected != undefined && this.fcIdSelected.length > 0) {
        var factory = JSON.parse(this.fcIdSelected)
        var shops = factory.child
        for (var i = 0; i < shops.length; i++) {
          if (shops[i].hasOwnProperty('deptCode')) {
            arr.push({
              label: shops[i].deptName,
              id: shops[i].deptID,
              value: JSON.stringify(shops[i]),
              deptLevel: shops[i].deptLevel,
              parent: 0
            })
          }
        }
      }
      return arr
    },
    sectionList: function () {
      var arr = []
      if (this.shopSelected != undefined && this.shopSelected.length > 0) {
        var shop = JSON.parse(this.shopSelected)
        var vsms = shop.child
        for (var i = 0; i < vsms.length; i++) {
          if (vsms[i].hasOwnProperty('deptCode')) {
            arr.push({
              label: vsms[i].deptName,
              id: vsms[i].deptID,
              value: JSON.stringify(vsms[i]),
              deptLevel: vsms[i].deptLevel,
              parent: 0
            })
          }
        }
      }
      return arr
    },
    lineList: function () {
      var arr = []
      if (this.sectionSelected != undefined && this.sectionSelected.length > 0) {
        var vsm = JSON.parse(this.sectionSelected)
        var lines = vsm.child
        for (var i = 0; i < lines.length; i++) {
          if (lines[i].hasOwnProperty('deptCode')) {
            arr.push({
              label: lines[i].deptName,
              id: lines[i].deptID,
              value: JSON.stringify(lines[i]),
              deptLevel: lines[i].deptLevel,
              parent: 0
            })
          }
        }
      }
      return arr
    }
  },
  destroyed() {
    // 在页面销毁后，清除计时器
    this.clear()
  },
  created() {
    this.dataRefreh()
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      // this.userInfo = sessionStorage.getItem("userInfo")
      this.userInfo = this.$store.state.userInfo
      var role = this.userInfo.roles
      for (var i = 0; i < role.length; i++) {
        //所有工厂数据
        if (role[i].factoryId == 0) {
          this.ischeck = false
          this.role = role[i]
          this.isclear = true
          break
        } else {
          if (this.userInfo.factoryId == role[i].factoryId) {
            this.role = role[i]
          }
        }
      }
      this.getData()
    },
    // 定时刷新数据函数
    dataRefreh() {
      // 计时器正在进行中，退出函数
      if (this.intervalId != null) {
        return
      }
      // 计时器为空，操作
      this.intervalId = setInterval(() => {
        console.log('刷新' + new Date())
        this.getPlanMaintainTotality() //加载数据函数
      }, 5000)
    },
    // 停止定时器
    clear() {
      clearInterval(this.intervalId) //清除计时器
      this.intervalId = null //设置为null
    },
    handleClick(tab, event) {
      this.getPlanMaintainPage()
    },
    paginationChange(val) {
      this.searchParams.pageSize = val
      this.getPlanMaintainPage()
    },
    paginationCurrentChange(val) {
      this.searchParams.page = val
      this.getPlanMaintainPage()
    },
    fcChange: function () {
      this.isChange = false
      this.shopSelected = ''
      this.searchParams.page = 1
      this.getPlanMaintainTotality()
    },
    shopChange: function () {
      this.sectionSelected = ''
      this.lineSelected = ''
      this.searchParams.page = 1
      this.getPlanMaintainTotality()
    },
    sectionChange: function () {
      this.lineSelected = ''
      this.searchParams.page = 1
      this.getPlanMaintainTotality()
    },
    lineChange: function () {
      this.getPlanMaintainTotality()
    },
    planCurrentChange(row) {
      if (row != null) {
        var array = JSON.parse(JSON.stringify(row))
        if (this.fcIdSelected != undefined && this.fcIdSelected != '') {
          array['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
        }
        if (this.shopSelected != undefined && this.shopSelected != '') {
          array['shopCode'] = JSON.parse(this.shopSelected).deptCode
        }
        if (this.sectionSelected != undefined && this.sectionSelected != '') {
          array['sectionCode'] = JSON.parse(this.sectionSelected).deptCode
        }
        if (this.lineSelected != undefined && this.lineSelected != '') {
          array['lineCode'] = JSON.parse(this.lineSelected).deptCode
        }
        this.$router.push({
          name: 'planMantainOrder',
          params: {
            planSpe: array
          }
        })
      }
    },
    getFacility() {
      this.$router.push({
        name: 'facilitySpectaculars',
        params: {
          full: 'true'
        }
      })
    },
    getPlanMaintainTotality() {
      this.searchParams.pageNum = 1
      let queryParams = {
        quarter: this.quarter,
      }
      var self = this
      if (self.fcIdSelected != undefined && self.fcIdSelected != '') {
        queryParams['fcCode'] = JSON.parse(self.fcIdSelected).deptCode
      }
      if (self.shopSelected != undefined && self.shopSelected != '') {
        queryParams['shopCode'] = JSON.parse(self.shopSelected).deptCode
      }
      if (self.sectionSelected != undefined && self.sectionSelected != '') {
        queryParams['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
      }
      if (self.lineSelected != undefined && self.lineSelected != '') {
        queryParams['lineCode'] = JSON.parse(self.lineSelected).deptCode
      }
      if (self.timeValue != undefined && self.timeValue != '') {
        queryParams['mothDate'] = moment(self.timeValue).format('YYYY-MM') + '-01'
      }
      if (self.year != undefined && self.year != '') {
        queryParams['year'] = moment(self.year).format('YYYY')
      }
      let options = {
        method: 'get',
        url: this.$api.planMaintainTotality,
        params: queryParams
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          self.searchData = JSON.parse(JSON.stringify(response.data))
          self.getPlanMaintainPage()
        } else {
          self.searchData = {
            completionRate: '',
            completionTotal: '',
            total: ''
          }
          self.tableData = []
          this.searchParams.pageCount = 0
        }
      })
    },
    getPlanMaintainPage() {
      let queryParams = {
        pageSize: this.searchParams.pageSize,
        pageNum: this.searchParams.page,
        quarter: this.quarter,
      }
      var self = this
      if (self.fcIdSelected != undefined && self.fcIdSelected != '') {
        queryParams['fcCode'] = JSON.parse(self.fcIdSelected).deptCode
      }
      if (self.shopSelected != undefined && self.shopSelected != '') {
        queryParams['shopCode'] = JSON.parse(self.shopSelected).deptCode
      }
      if (self.sectionSelected != undefined && self.sectionSelected != '') {
        queryParams['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
      }
      if (self.lineSelected != undefined && self.lineSelected != '') {
        queryParams['lineCode'] = JSON.parse(self.lineSelected).deptCode
      }
      if (self.timeValue != undefined && self.timeValue != '') {
        queryParams['mothDate'] = moment(self.timeValue).format('YYYY-MM') + '-01'
      }
      if (self.year != undefined && self.year != '') {
        queryParams['year'] = moment(self.year).format('YYYY')
      }
      if (self.activeName != undefined && self.activeName != '') {
        queryParams['pmoStatus'] = self.activeName
      }
      let options = {
        method: 'GET',
        url: this.$api.planMaintainPage,
        params: queryParams
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.tableData = response.data.list
          this.searchParams.pageCount = response.data.total
        }
      })
    },
    getData() {
      var self = this
      let options = {
        method: 'GET',
        url: this.$api.departTree
      }
      this.$http.request(options).then(response => {
        self.factoryTree = response.data
        for (var i = 0; i < self.factoryTree.length; i++) {
          if (self.ischeck && self.isChange && !self.isSkip) {
            if (self.factoryTree[i].deptID == self.role.factoryId) {
              self.fcIdSelected = JSON.stringify(self.factoryTree[i])
            }
          } else if (!self.ischeck && self.isChange && !self.isSkip) {
            self.fcIdSelected = JSON.stringify(self.factoryTree[0])
          }
          //新工厂看板
          if (self.$route.params.upkeepState != undefined && self.$route.params.upkeepState != '') {
            self.isSkip = true
            self.upkeepStateArray = self.$route.params.upkeepState
            if (self.upkeepStateArray.hasOwnProperty('pmoStatus')) {
              self.activeName = self.upkeepStateArray.pmoStatus
            }
            let fcCodeList = []
            if (self.upkeepStateArray.hasOwnProperty('fcCode')) {
              fcCodeList = self.upkeepStateArray.fcCode.split(',')
            }
            if (fcCodeList.length > 1) {
              self.upkeepStateArray.fcCode = fcCodeList[0]
            }
            if (self.upkeepStateArray.hasOwnProperty('fcCode')) {
              if (self.factoryTree[i].deptCode == self.upkeepStateArray.fcCode) {
                self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                if (self.upkeepStateArray.hasOwnProperty('shopCode')) {
                  var shops = JSON.parse(self.fcIdSelected).child
                  for (let j = 0; j < shops.length; j++) {
                    if (shops[j].hasOwnProperty('deptCode')) {
                      if (shops[j].deptCode == self.upkeepStateArray.shopCode) {
                        self.shopSelected = JSON.stringify(shops[j])
                        if (self.upkeepStateArray.hasOwnProperty('sectionCode')) {
                          var sections = JSON.parse(self.shopSelected).child
                          for (let k = 0; k < sections.length; k++) {
                            if (sections[k].hasOwnProperty('deptCode')) {
                              if (sections[k].deptCode == self.upkeepStateArray.sectionCode) {
                                self.sectionSelected = JSON.stringify(sections[k])
                                if (self.upkeepStateArray.hasOwnProperty('lineCode')) {
                                  var lines = JSON.parse(self.sectionSelected).child
                                  for (let l = 0; l < lines.length; l++) {
                                    if (lines[l].hasOwnProperty('deptCode')) {
                                      if (lines[l].deptCode == self.upkeepStateArray.lineCode) {
                                        self.lineSelected = JSON.stringify(lines[l])
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          } else {
            self.isSkip = false
          }
        }
        this.getPlanMaintainTotality()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .searchBox {
      display: inherit;
  }

  .selectInfo {
      display: flex;
  }

  .topSty {
      margin-left: 2vw;
  }

  .topsele {
      flex: 10;
      display: flex;
      flex-wrap: wrap;
      margin-top: -20px;

      div {
          margin-top: 10px;
      }
  }

  .currentNum {
      width: 100%;
      margin-top: -1vw;
  }

  .currentTit {
      width: 100%;
      height: 7vh;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
  }

  .Sty1 {
      margin-top: 2vh;
  }

  .styColor1 {
      color: #8bafe3;
  }

  .styBgColor2 {
      background-color: #d95043;
  }

  .tabs {
      width: 100%;
      margin: 2vh 1vw 1vh 1vw;
      border: 1px #ccc solid;
  }
</style>
